import React from "react";
import PropTypes from "prop-types";
import { makeStyles, Typography } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  title: {
    fontWeight: "200",
  },
}));

/**
 * Description text for diferents cards
 * @returns {React}
 */
export const DescriptionText = ({ children, variant }) => {
  const classes = styles();
  return (
    <Typography variant={variant} className={classes.title}>
      {children}
    </Typography>
  );
};

DescriptionText.propTypes = {
  /**
   * Inheritance of the text that the component contains
   */
  children: PropTypes.node,
  /**
   * Variant typography
   */
  variant: PropTypes.string,
};
